import {Components, Theme} from '@mui/material/styles';
import {paperClasses} from '@mui/material/Paper';
import {listItemIconClasses} from '@mui/material/ListItemIcon';
import {menuItemClasses} from '@mui/material/MenuItem';
import {alpha} from '@mui/material';

export const menu = (theme: Theme): Partial<Components> => ({
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        color: 'inherit',

        '> svg': {
          width: 16,
          height: 16,
        },
      },
    },
  },
  MuiMenu: {
    styleOverrides: {
      list: {
        display: 'grid',
        gap: theme.spacing(1),
      },
      paper: {
        [`&.${paperClasses.root}`]: {
          borderRadius: theme.shape.borderRadiusRegular,
        },
      },
    },
  },
  MuiMenuItem: {
    defaultProps: {disableRipple: true},
    styleOverrides: {
      root: {
        ...theme.typography.body3,
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),

        [`&.${menuItemClasses.selected}:hover, &:hover`]: {
          backgroundColor: alpha(theme.palette.primary.main, 0.04),
        },

        [`& .${listItemIconClasses.root}`]: {
          minWidth: 20 + 8,

          '> svg': {
            width: 20,
            height: 20,
          },
        },

        [`&.${menuItemClasses.selected}`]: {
          color: theme.palette.primary.main,

          ['&:hover']: {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
          },
        },
      },
      dense: {
        [`& .${listItemIconClasses.root}`]: {
          minWidth: 16 + 8,

          ' > svg': {
            width: 16,
            height: 16,
          },
        },
      },
    },
  },
});
